import router from '../router'
import Cookies from 'js-cookie'
import { checkLogin, useInfoApi, comiCorderCreate} from '@/utils/api'
const TokenKey = 'Ctoken'

function removeToken(){
//     return localStorage.removeItem(TokenKey)
    // Cookies.remove(TokenKey,{Domain:'.zhangwen.cn'})
    Cookies.remove(TokenKey)

 }
function navTo(path,query){
    router.push({path,query})
}
/**跳转到detail页  
 * id:漫画id
*/
function navToDetail(id){
    router.push({path:'/detail',query:{id}})
}
/**获取用户信息 */
function getUserInfo() {
    // if(JSON.parse(localStorage.getItem('info')).userid){
        return JSON.parse(localStorage.getItem('info'))
    // }else{
    //     return{
    //         autoSub:0,
    //         nickname: "",
    //         userid: "",
    //         vip: false,
    //         vipEndDate: ''
    //     }
    // }
}
/**刷新用户信息 */
function refreshUserInfo() {
    useInfoApi().then((res)=>{
        localStorage.setItem('info',JSON.stringify(res.data))
    })
}
/**删除用户信息 */
function removeUserInfo() {
    localStorage.setItem('info',JSON.stringify({vip:false}))
}
/**支付宝支付 
 * @param gearId  挡位id
 * @param path  支付完成回调路径
*/
function payMoneyPublic(gearId,path){
    comiCorderCreate({gearId,path}).then((res =>{
        const div = document.createElement("divform");
        div.innerHTML = res.data.body;
        document.body.appendChild(div);
        document.forms[0].submit();
        div.remove();
    }))
}
export {
    navTo,
    removeToken,
    navToDetail,
    getUserInfo,
    refreshUserInfo,
    payMoneyPublic,
    removeUserInfo,
}